import { render, staticRenderFns } from "./NavigationFooterItem.vue?vue&type=template&id=73cbca1f&"
import script from "./NavigationFooterItem.vue?vue&type=script&lang=js&"
export * from "./NavigationFooterItem.vue?vue&type=script&lang=js&"
import style0 from "./NavigationFooterItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports